import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { Outlet } from 'react-router-dom';

export default function DebitLayout() {
  const bg = CC.useColorModeValue('white', 'gray.800');
  return (
    <CC.VStack>
      <CC.Container maxW="container.xxl" bg={bg} py="1em">
        <Outlet />
      </CC.Container>
    </CC.VStack>
  );
}
